import * as React from "react";
import { getGrantedAuthorities } from "../../utils/authorities";

const getIsWritePermissionGranted = (
  permissionComponent: string,
  grantedAuthorities: Array<string>,
) => {
  const grantedAuthoritiesForComponent = grantedAuthorities.filter(
    (authority) => authority.includes(permissionComponent),
  );
  const isWritePermission = grantedAuthoritiesForComponent.some(
    (authority) =>
      authority.includes("CREATE") ||
      authority.includes("UPDATE") ||
      authority.includes("DELETE"),
  );

  return isWritePermission;
};

/* Checking if the user has authority. Load that page only if there is an authority. */
const withAuthority = (Component: any, permission: string) => (props: any) => {
  const grantedAuthorities = getGrantedAuthorities();

  if (grantedAuthorities.includes(permission)) {
    const [permissionComponent, _] = permission.split(":");
    const isWritePermissionGranted = getIsWritePermissionGranted(
      permissionComponent,
      grantedAuthorities,
    );
    if (isWritePermissionGranted) {
      return <Component {...props} isAuthorized />;
    }
    return <Component {...props} />;
  }
  return null;
};

export default withAuthority;

/**
 * Checks if a user has WRITE access to a specific permission component.
 * @param permission A string like "DASHBOARD:READ" or "DELIVERY:CREATE"
 * @returns boolean
 */
export const isUserAuthorized = (permission: string): boolean => {
  const grantedAuthorities = getGrantedAuthorities();

  if (!grantedAuthorities.includes(permission)) return false;

  const [permissionComponent] = permission.split(":");

  const hasWritePermission = grantedAuthorities.some(
    (authority) =>
      authority.startsWith(permissionComponent + ":") &&
      (authority.includes("CREATE") ||
        authority.includes("UPDATE") ||
        authority.includes("DELETE"))
  );

  return hasWritePermission;
};